import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { CATEGORY_CODES } from '_constants/categories';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';
import { selectError, selectLoading, selectPasswordResetStatus } from '_store/user/selector';
import { resetPassword } from '_store/user/slice';

import { ReactComponent as LogoSvg } from 'assets/images/lumen-logo-dark.svg';

import ForgotPasswordForm from 'components/features/auth/ForgotPasswordForm';
import Card from 'components/shared/layouts/Card';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: ${theme.spaces.regular}px;
  background-color: ${hexToRGBA(theme.colors.cyanBlue, 0.08)};
`;

const StyledInnerContainer = styled.div`
  max-width: 480px;
  width: 100%;
`;

const StyledLogoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${theme.spaces.largeX}px;
`;

const ForgotPasswordPage = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const success = useSelector(selectPasswordResetStatus);
  const error = useSelector(selectError);

  const handleSubmit = (values) => {
    if (values) {
      const { email } = values;
      dispatch(resetPassword({ email, category: CATEGORY_CODES.main }));
    }
  };

  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Card>
          <StyledLogoContainer>
            <LogoSvg />
          </StyledLogoContainer>
          <ForgotPasswordForm loading={loading} success={success} error={error} onSubmit={handleSubmit} />
        </Card>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default ForgotPasswordPage;
